<template>
    <b-modal id="modalItems" data-backdrop="static" data-keyboard="false" size="xl" v-model="exibirRotinas" centered>
        <template #modal-header>
            <div class="col-10">
                <h4>Configuração de rotinas!</h4>
            </div>
        </template>

        <div class="col-12 ">
            <div class=" mt-3 ">
                <h6>Nome rotina:</h6>
                <input class="form-control" v-model="nome_rotina" />
                <!-- <h6>Selecione uma rotina:</h6>
                <v-select :options="rotinas" v-model="selectRotina" :disabled="disabledRotina">
                </v-select> -->
            </div>
            <div class="row">
                <div class="col-6 mt-3">
                    <h6>Caminho:</h6>
                    <input class="form-control" v-model="caminho_rotina" />
                    <!-- <v-select :options="dias" v-model="selectDia">
                    </v-select> -->
                </div>
                <div class="col-6 mt-3 ">
                    <h6>Observação:</h6>
                    <input type="text" class="form-control" v-model="observacao_rotina">
                </div>
            </div>
        </div>

        <template #modal-footer>
            <div class="w-100">
                <div class="row center" style="justify-content: center; ">
                    <div class="row center" style="justify-content: center; ">
                        <b-button class="mr-2" variant="danger" size="lg" @click="$emit('closeModal')">
                            Fechar
                        </b-button>
                        <b-button size="lg" variant="success" @click="salvar">
                            Salvar
                        </b-button>
                    </div>
                </div>
            </div>
        </template>
    </b-modal>
</template>

<script>
export default {
    data() {
        return {
            nome_rotina: '',
            caminho_rotina: '',
            observacao_rotina: '',
            exibirRotinas: true,
            selectRotina: '',
            selectDia: '',
            disabledRotina: true,
            acaoGlobal: '',
            nr_sequencial: ''
        }
    },

    props: {
        rotina: {}
    },

    computed: {
        rotinas() {
            const rotinas = this.$store.getters['painel/getRotinas']

            return rotinas.map(rotina => {
                return {
                    ...rotina,
                    label: rotina.nome_rotina.toUpperCase()
                }
            })
        },

        dias() {
            const dias = this.$store.getters['painel/getDias']

            return dias.map(dia => {
                return {
                    ...dia,
                    label: dia.dia_semana
                }
            })
        }
    },

    methods: {
        salvar() {
            const data = {
                nr_sequencial: this.nr_sequencial,
                nome_rotina: this.nome_rotina,
                caminho_rotina: this.caminho_rotina,
                observacao_rotina: this.observacao_rotina,
                acao_global: this.acaoGlobal
            }

            this.$store.dispatch('painel/acaoRotina', { data: data }).then(response => {
                this.$emit('closeModal')
                this.$store.dispatch('painel/getRotinas')
            })
        }
    },

    created() {
        if (this.rotina == null) {
            console.log('Salvar')
            this.acaoGlobal = 'salvar'
        } else {
            this.nr_sequencial = this.rotina.nr_sequencial
            this.nome_rotina = this.rotina.nome_rotina
            this.caminho_rotina = this.rotina.ds_caminho
            this.observacao_rotina = this.rotina.ds_observacao
            this.acaoGlobal = 'editar'
        }
    }

}
</script>
<style src="./style.css" ></style>
